import React from "react";
import PropTypes from "prop-types";

import MuiPhoneNumber from "material-ui-phone-number";

const CustomPhoneNumber = (props) => {
  const { value, setValue, disabled, defaultCountry, onlyCountries } = props;

  const handlePhoneChange = (value) => {
    const modifiedValue = value.replace(/[^0-9]/g, "");
    if (modifiedValue) {
      setValue(modifiedValue);
    }
  };

  return (
    <div>
      <MuiPhoneNumber
        style={{ marginBottom: 8, marginTop: 8 }}
        defaultCountry={defaultCountry}
        onlyCountries={onlyCountries}
        countryCodeEditable={false}
        value={value}
        onChange={handlePhoneChange}
        variant="outlined"
        size="small"
        disabled={disabled}
        fullWidth
        autoFormat={false}
      />
    </div>
  );
};
CustomPhoneNumber.propTypes = {
  label: PropTypes.string,
  labelClasses: PropTypes.string,
  classes: PropTypes.string,
  value: PropTypes.string,
  setValue: PropTypes.func,
  disabled: PropTypes.bool,
  defaultCountry: PropTypes.string,
  onlyCountries: PropTypes.array,
};

export default CustomPhoneNumber;
